module.exports = __webpack_public_path__ + "img/img-2.9e17cc4b.png";